import styled from 'styled-components';

const FieldStyleWrapperSC = styled.div`
  .field-label {
    margin-bottom: 15px;
  }

  .field-error {
    margin-top: 5px;
  }
`;

export default FieldStyleWrapperSC;
